import { Flex } from '../../Core';
import { AutocompleteDropdown, AutocompleteResult } from '../../Form/AutocompleteDropdown';
import type { AutocompleteDropdownProps } from '../../Form/AutocompleteDropdown/types';
import { Icon, type IconName } from '../../Icons';
import { Tooltip } from '../../Tooltip';

export const PropertyDropdown = <T extends { icon: IconName; tooltip?: string }>(
  props: Omit<AutocompleteDropdownProps<T>, 'renderResult'>
) => {
  const prefix = (item: T) => (
    <Flex mr="spacing4" alignItems="center">
      <Icon icon={item.icon} />
    </Flex>
  );

  return (
    <AutocompleteDropdown
      {...props}
      renderResult={(searchResult, disabled, searchString) => {
        const result = AutocompleteResult(searchResult, disabled, searchString, prefix);
        const tooltip = searchResult.item.item.tooltip;
        if (!tooltip) {
          return result;
        }
        return (
          <Tooltip
            tooltip={tooltip}
            placement="right"
            delay={0}
            interactive={false}
            targetStyle={{ display: 'flex', width: '100%' }}
            tooltipTestID="filter-builder-property-tooltip"
          >
            {result}
          </Tooltip>
        );
      }}
    />
  );
};
